<template lang="pug">

  Accordion(:startOpen="true")
    template(slot="heading")
      span.fs-19(style="text-align: center;") configuração para compensação

    template
      .fields
        .auto-acc-tm
          PCheckbox(
            label="Acumular horas automaticamente?"
            useState="timeoff/details/autoAccTm"
          )
        .auto-comp-stm
          PCheckbox(
            label="Compensar horas automaticamente?"
            useState="timeoff/details/autoCompStm"
          )
        .negative-balance
          PCheckbox(
            label="Permitir balanço negativo?"
            useState="timeoff/details/negativeBalance"
          )
        .is-approved
          PCheckbox(
            label="Aprovação automática?"
            useState="timeoff/details/isApproved"
          )
        .partial-acc
          PCheckbox(
            label="Considerar acúmulo parcial de horas caso apontamentos ultrapassem limites?"
            useState="timeoff/details/partialAcc"
          )
        .auto-compensate
          PCheckbox(
            label="Utilizar autocompensação automatica?"
            useState="timeoff/details/autoCompensate"
          )
        .window-type-and-expiration-cycle(v-if="autoCompensate")
          PSelect(
            useState="timeoff/details/windowType"
            labelItem="name"
            title="Qual é o tamanho do ciclo?"
            :allowEmpty="false"
          )
          PTextField(
            label="Quantos ciclos até o vencimento?"
            type="number"
            useState="timeoff/details/windowExpirationCycle"
          )
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CompensationsConfig',
  computed: {
    ...mapState('timeoff/details', ['loading', 'autoCompensate'])
  }
}
</script>

<style lang="scss" scoped>
.fields {
  display: grid;
  grid-template-columns: .5fr .7fr 1fr;
  grid-template-areas:
    "auto-acc-tm partial-acc window-type-and-expiration-cycle"
    "auto-comp-stm auto-compensate window-type-and-expiration-cycle"
    "negative-balance . window-type-and-expiration-cycle"
    "is-approved . window-type-and-expiration-cycle";

  .auto-acc-tm { grid-area: auto-acc-tm }
  .auto-comp-stm { grid-area: auto-comp-stm }
  .negative-balance { grid-area: negative-balance }
  .is-approved { grid-area: is-approved }
  .partial-acc { grid-area: partial-acc }
  .auto-compensate { grid-area: auto-compensate }
  .window-type-and-expiration-cycle {
    grid-area: window-type-and-expiration-cycle;
    align-self: start;

    margin-top: 5px;
    display: flex;

    & > * {
      width: 280px;
      padding-right: 30px;
    }
  }
}

</style>
